import styled from "styled-components";
import { DEVICE_MAP } from "../utils";
const GRID_COLS = {
    xs: 4,
    s: 4,
    m: 8,
    l: 12,
    xl: 12,
};
export const Col = styled.div.withConfig({
    shouldForwardProp: (prop) => ![
        "size",
        "theme",
        "order",
        "justify",
        "align",
        "offset",
        "reverse",
        "xs",
        "s",
        "m",
        "l",
        "xl",
    ].includes(prop),
}) `
  flex-basis: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: ${({ flex }) => (flex ? "flex" : "block")};
  padding-right: 0.5rem;
  padding-left: 0.5rem;

  @media ${({ theme }) => theme.device.medium} {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }

  ${({ size: sizeInput, theme }) => {
    let size = sizeInput;
    if (!Array.isArray(size) && typeof size !== "object") {
        size = [4, 8, 12];
    }
    if (Array.isArray(size)) {
        return `
        ${size.length >= 1
            ? `
          flex-basis: ${(size[0] / 4) * 100}%;
          max-width: ${(size[0] / 4) * 100}%;
          `
            : ""}
        ${size.length >= 2
            ? `
          @media ${theme.device.medium} {
            flex-basis: ${(size[1] / 8) * 100}%;
            max-width: ${(size[1] / 8) * 100}%;
          }`
            : ""}

          ${size.length >= 3
            ? `
          @media ${theme.device.large} {
            flex-basis: ${(size[2] / 12) * 100}%;
            max-width: ${(size[2] / 12) * 100}%;
          }`
            : ""}

          ${size.length === 4
            ? `
          @media ${theme.device.xlarge} {
            flex-basis: ${(size[3] / 12) * 100}%;
            max-width: ${(size[3] / 12) * 100}%;
          }`
            : ""}
      `;
    }
    return `${size.xs
        ? `
      flex-basis: ${(size.xs / 4) * 100}%;
      max-width: ${(size.xs / 4) * 100}%;
      `
        : ""}
    ${size.s
        ? `
      @media ${theme.device.small} {
        flex-basis: ${(size.s / 4) * 100}%;
        max-width: ${(size.s / 4) * 100}%;
      }`
        : ""}

    ${size.m
        ? `
      @media ${theme.device.medium} {
        flex-basis: ${(size.m / 8) * 100}%;
        max-width: ${(size.m / 8) * 100}%;
      }`
        : ""}

    ${size.l
        ? `
      @media ${theme.device.large} {
        flex-basis: ${(size.l / 12) * 100}%;
        max-width: ${(size.l / 12) * 100}%;
      }`
        : ""}

    ${size.xl
        ? `
      @media ${theme.device.xlarge} {
        flex-basis: ${(size.xl / 12) * 100}%;
        max-width: ${(size.xl / 12) * 100}%;
      }`
        : ""}
    `;
}}

  ${({ reverse, theme }) => {
    if (!reverse)
        return `
      flex-direction: column;
    `;
    if (typeof reverse === "object") {
        return Object.keys(reverse).map((responsiveSize) => `
        @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
          flex-direction: ${reverse[responsiveSize] ? "column-reverse" : "column"};
        }
      `);
    }
    return `
      flex-direction: column-reverse;
    `;
}}

  ${({ offset, theme }) => {
    if (!offset)
        return "";
    if (typeof offset === "object") {
        return Object.keys(offset).map((responsiveSize) => `
          @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
            margin-left: ${(offset[responsiveSize] / GRID_COLS[responsiveSize]) * 100}%;
          }
        `);
    }
    return "";
}}

  ${({ order, theme }) => {
    if (!order)
        return "";
    if (typeof order === "object") {
        return Object.keys(order).map((responsiveSize) => `
                @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
                  order: ${order[responsiveSize]};
                }
              `);
    }
    return `order: ${order};`;
}}

  ${({ justify, theme }) => {
    if (!justify)
        return "";
    if (typeof justify === "object") {
        return Object.keys(justify).map((responsiveSize) => `
            @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
              justify-content: ${justify[responsiveSize]};
            }
          `);
    }
    return `justify-content: ${justify};`;
}}


  ${({ align, theme }) => {
    if (!align)
        return "";
    if (typeof align === "object") {
        return Object.keys(align).map((responsiveSize) => `
            @media ${theme.device[DEVICE_MAP[responsiveSize]]} {
              align-items: ${align[responsiveSize]};
            }
          `);
    }
    return `align-items: ${align};`;
}}
`;
